<template>
    <div>
      <confirm-delete-display-condition v-if="conditionToDelete" />
      <div v-else>
        <div id="button-div" v-if="!editConditions">
            <button class="btn btn-default" @click="activateEdit">{{ $t('filters.add_filter') }}</button>
        </div>
        <display-condition-form v-if="editConditions" @condition-applied="closeModal" />
        <display-conditions-list v-else @condition-applied="closeModal" />
      </div>
    </div>
</template>

<script>
import DisplayConditionsList from './DisplayConditionsList';
import DisplayConditionForm from './DisplayConditionForm';
import ConfirmDeleteDisplayCondition from './ConfirmDeleteDisplayCondition';
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'DisplayConditionsContainer',
  computed: mapState({
    editConditions: state => state.displayModule.editConditions,
    conditionToDelete: state => state.displayModule.conditionToDelete
  }),
  components: {
    DisplayConditionsList,
    DisplayConditionForm,
    ConfirmDeleteDisplayCondition
  },
  methods: {
    ...mapMutations('displayModule', ['setEditConditions']),
    activateEdit: function() {
      this.setEditConditions(true);
    },
    closeModal() {
      this.$emit('condition-applied');
    }
  }
};
</script>

<style scoped>
#button-div {
    text-align: left;
}
</style>
